'use strict';
var React = require('react');

class LandingComponent extends React.Component {

    render() {
        return null;
    }
}

module.exports = LandingComponent;